import * as actionTypes from './types';
import { request } from '../../request/index';

export const router = {
    setSubscription:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_SUBSCRIPTION,
				payload: data,
			});
		},
    setAccountTypes:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_ACCOUNT_TYPES,
				payload: data,
			});
		},     
    setGuestApplication:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_GUEST_APPLICATION,
				payload: data,
			});
		}, 
    setB2CApplication:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_B2C_APPLICATION,
				payload: data,
			});
		},     
    setB2BApplication:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_B2B_APPLICATION,
				payload: data,
			});
		},             
    setSCPApplication:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_SCP_APPLICATION,
				payload: data,
			});
		},  
    setServiceApplication:
		(data: any) => async (dispatch: any) => {
            console.log('Setting service data', data)
			await dispatch({
				type: actionTypes.SET_SERVICE_APPLICATION,
				payload: data,
			});
        },      
    setManagementApplication:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_MANAGEMENT_APPLICATION,
				payload: data,
			});
		},            
    setIsB2CAuthenticated:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_IS_B2C_AUTHENTICATED,
				payload: data,
			});
		}, 
    setIsB2BAuthenticated:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_IS_B2B_AUTHENTICATED,
				payload: data,
			});
		},         
    setIsSCPAuthenticated:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_IS_SCP_AUTHENTICATED,
				payload: data,
			});
		},        
    setIsServiceAuthenticated:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_IS_SERVICE_AUTHENTICATED,
				payload: data,
			});
		},     
    setIsManagementAuthenticated:
		(data: any) => async (dispatch: any) => {
			await dispatch({
				type: actionTypes.SET_IS_MANAGEMENT_AUTHENTICATED,
				payload: data,
			});
		},                                      
    resetState:
        (props = {}) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_RESET_STATE,
                });
            },
    resetAction:
        ({ actionType }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_RESET_ACTION,
                    keyState: actionType,
                    payload: null,
                });
            },
    currentItem:
        ({ data }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_CURRENT_ITEM,
                    payload: { ...data },
                });
            },
    currentAction:
        ({ actionType, data }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_CURRENT_ACTION,
                    keyState: actionType,
                    payload: { ...data },
                });
            },
    list:
        ({ url, jsonData, entity, options }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_REQUEST_LOADING,
                    keyState: 'list',
                    payload: null,
                });

                let data = await request.list({ url, jsonData, entity, options });

                if (data?.status === 200) {
                    const result = {
                        items: data?.data?.Records,
                        pagination:
                            data?.data?.Pagination,
                    };
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_SUCCESS,
                        keyState: 'list',
                        payload: result,
                    });
                } else {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_FAILED,
                        keyState: 'list',
                        payload: null,
                    });
                }
            },
    query:
        ({ url, jsonData, entity }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_REQUEST_LOADING,
                    keyState: 'query',
                    payload: null,
                });

                let data = await request.query({ url, jsonData, entity });

                if (data?.status === 200) {
                    const result = {
                        items: data?.data?.Records[0],
                        // pagination:
                        // {
                        //     current: parseInt(data.pagination.page, 10),
                        //     pageSize: parseInt(data.pagination.pages, 10),
                        //     showSizeChanger: false,
                        //     total: parseInt(data.pagination.count, 10),
                        // },
                    };
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_SUCCESS,
                        keyState: 'query',
                        payload: result,
                    });
                } else {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_FAILED,
                        keyState: 'query',
                        payload: null,
                    });
                }
            },
    // filter:
    //     ({ entity, options = { page: 1 } }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.ROUTER_REQUEST_LOADING,
    //                 keyState: 'filter',
    //                 payload: null,
    //             });

    //             let data = await request.filter({ entity, options });

    //             if (data.success === true) {
    //                 const result = {
    //                     items: data.result,
    //                     pagination: {
    //                         current: parseInt(data.pagination.page, 10),
    //                         pageSize: 10,
    //                         showSizeChanger: false,
    //                         total: parseInt(data.pagination.count, 10),
    //                     },
    //                 };
    //                 dispatch({
    //                     type: actionTypes.ROUTER_REQUEST_SUCCESS,
    //                     keyState: 'filter',
    //                     payload: result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.ROUTER_REQUEST_FAILED,
    //                     keyState: 'filter',
    //                     payload: null,
    //                 });
    //             }
    //         },
    // count:
    // ({ url, jsonData, entity }: any) =>
    //     async (dispatch: any) => {
    //         await dispatch({
    //             type: actionTypes.ROUTER_REQUEST_LOADING,
    //             keyState: 'count',
    //             payload: null,
    //         });

    //         let data = await request.count({ url, jsonData, entity });

    //         if (data?.status === 200) {
    //             const result: any = {
    //                 items: data?.data?.Records[0],
    //             };
    //             await dispatch({
    //                 type: actionTypes.ROUTER_REQUEST_SUCCESS,
    //                 keyState: 'count',
    //                 payload: result?.ShoppingCartItems?.length || null,
    //             });
    //         } else {
    //             await dispatch({
    //                 type: actionTypes.ROUTER_REQUEST_FAILED,
    //                 keyState: 'count',
    //                 payload: null,
    //             });
    //         }
    //     },
    create:
        ({ url, jsonData, entity }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_REQUEST_LOADING,
                    keyState: 'create',
                    payload: null,
                });

                let data = await request.create({ url, jsonData, entity });

                if (data.status === 200) {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_SUCCESS,
                        keyState: 'create',
                        payload: data.result,
                    });

                    await dispatch({
                        type: actionTypes.ROUTER_CURRENT_ITEM,
                        payload: data.result,
                    });
                } else {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_FAILED,
                        keyState: 'create',
                        payload: null,
                    });
                }
            },
    read:
        ({ url, entity }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_REQUEST_LOADING,
                    keyState: 'read',
                    payload: null,
                });

                let data = await request.read({ url, entity });

                if (data.status === 200) {
                    await dispatch({
                        type: actionTypes.ROUTER_CURRENT_ITEM,
                        payload: data.result,
                    });
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_SUCCESS,
                        keyState: 'read',
                        payload: data.result,
                    });
                } else {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_FAILED,
                        keyState: 'read',
                        payload: null,
                    });
                }
            },
    update:
        ({ url, jsonData, entity }: any) =>
            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_REQUEST_LOADING,
                    keyState: 'update',
                    payload: null,
                });

                let data = await request.update({ url, jsonData, entity });

                if (data.status === 200) {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_SUCCESS,
                        keyState: 'update',
                        payload: data.result,
                    });
                    console.log('cart update data.result', data.result)
                    await dispatch({
                        type: actionTypes.ROUTER_CURRENT_ITEM,
                        payload: data.result,
                    });
                } else {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_FAILED,
                        keyState: 'update',
                        payload: null,
                    });
                }
            },

    delete:
        ({ url, jsonData, entity }: any) =>

            async (dispatch: any) => {
                await dispatch({
                    type: actionTypes.ROUTER_REQUEST_LOADING,
                    keyState: 'delete',
                    payload: null,
                });

                let data = await request.delete({ url, jsonData, entity });

                if (data.success === 200) {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_SUCCESS,
                        keyState: 'delete',
                        payload: data.result,
                    });
                    await dispatch({
                        type: actionTypes.ROUTER_CURRENT_ITEM,
                        payload: data.result,
                    });
                } else {
                    await dispatch({
                        type: actionTypes.ROUTER_REQUEST_FAILED,
                        keyState: 'delete',
                        payload: null,
                    });
                }
            },

    // search:
    //     ({ entity, options = {} }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.ROUTER_REQUEST_LOADING,
    //                 keyState: 'search',
    //                 payload: null,
    //             });

    //             let data = await request.search({ entity, options });

    //             if (data.success === true) {
    //                 dispatch({
    //                     type: actionTypes.ROUTER_REQUEST_SUCCESS,
    //                     keyState: 'search',
    //                     payload: data.result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.ROUTER_REQUEST_FAILED,
    //                     keyState: 'search',
    //                     payload: null,
    //                 });
    //             }
    //         },
};